import { FC, ReactNode, useRef } from 'react';

import { BottomSheet, HSpacing, NavigationBar, Text, TooltipHover, VSpacing } from '@hh.ru/magritte-ui';
import { QuestionCircleOutlinedSize16 } from '@hh.ru/magritte-ui/icon';

import useOnOffState from 'hooks/common/useOnOffState';

import styles from 'components/common/TextWithTooltip/TextWithTooltip.module.less';

interface TextWithTooltipProps {
    textNode: ReactNode;
    textValue: string;
    tooltipContent?: ReactNode;
}

export const TextWithTooltip: FC<TextWithTooltipProps> = ({ textNode, textValue, tooltipContent }) => {
    const [showBottomSheet, setShowBottomSheetOn, setShowBottomSheetOff] = useOnOffState(false);

    const activatorRef = useRef<HTMLSpanElement | null>(null);

    return (
        <>
            <div className={styles.wrapper}>
                {textNode}
                <HSpacing default={6} />
                {tooltipContent && (
                    <QuestionCircleOutlinedSize16
                        initialColor="secondary"
                        ref={activatorRef}
                        onClick={setShowBottomSheetOn}
                    />
                )}
            </div>
            {tooltipContent && (
                <>
                    <TooltipHover
                        maxWidth={300}
                        activatorRef={activatorRef}
                        placement="top-center"
                        data-qa="form-label-tooltip"
                    >
                        {tooltipContent}
                    </TooltipHover>
                    <BottomSheet
                        visible={showBottomSheet}
                        onClose={setShowBottomSheetOff}
                        header={
                            <NavigationBar
                                title={<Text typography="title-5-semibold">{textValue}</Text>}
                                showDivider="always"
                            />
                        }
                    >
                        <Text typography="label-2-regular">{tooltipContent}</Text>
                        <VSpacing default={16} />
                    </BottomSheet>
                </>
            )}
        </>
    );
};
